/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react';
import 'moment/locale/pt';

import { Box, Button, FormControl, InputLabel, MenuItem, Select, Tab, Tabs, TextField, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import styled from 'styled-components';
import { enqueueSnackbar } from 'notistack';
import { GetFetch } from '../../../../../services/apiBase';

export default function filterModal({
  onClose,
  setFilter,
  setFilterStatus,
  setFilterPersonne,
  setFilterCpr
}) {
  
  const [value, setValue] = useState(0);
  const [select, setSelect] = useState('');
  const [personne, setPersonne] = useState({})
  const [personne_id, setPersonne_id] = useState(null);
  const [cprNumber, setCprNumber] = useState(null);

  const handleLoadPersonne = async () => {
    const response = await GetFetch(`subscription/listPersonne`);
    setPersonne(response.data)
  }

  const handleReturnInfos = () => {
    if (value === 0) {
      console.log('STATUS 1')
      if (select === '') {
        enqueueSnackbar('Selecione um status!', { variant: 'error' });
        return
      }
      else if (!select) {
        enqueueSnackbar('Selecione um status!', { variant: 'error' });
        return
      }
      setFilterStatus(select)
      setFilter(true)
      onClose()
    }
    else if (value === 1) {
      if (!personne_id) {
        enqueueSnackbar('Selecione um investidor!', { variant: 'error' });
        return
      }
      setFilterPersonne(personne_id)
      setFilter(true)
      onClose()
    } else if (value === 2) {
      if (!cprNumber) {
        enqueueSnackbar('Informe o número da CPR!', { variant: 'error' });
        return
      }
      setFilterCpr(cprNumber)
      setFilter(true)
      onClose()
    } else { onClose() }
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    handleLoadPersonne()
  }, [])

  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: 24,
      borderRadius: 2,
      backgroundColor: grey[300]
    }}>
      <Box sx={{
        padding: '16px',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff'
      }}>
        <Typography variant="h6" component="h2">
          Filtros
        </Typography>
      </Box>

      <Box sx={{
        margin: '16px',
        width: 400,
        height: '100%',
        backgroundColor: '#fff',
        borderRadius: 1,
      }}>
        <Box sx={{
          width: '100%'
        }}>
          <Box sx={{
            borderBottom: 1,
            borderColor: 'divider'
          }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="Por status" {...a11yProps(0)} />
              <Tab label="Por investidor" {...a11yProps(1)} />
              <Tab label="Por CPR" {...a11yProps(2)} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <Box sx={{ minWidth: 120 }}>
              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Status</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={select}
                    label="Status"
                    onChange={e => setSelect(e.target.value)}
                  >
                    <MenuItem value={'gerada'}>Gerada</MenuItem>
                    <MenuItem value={'ativa'}>Ativa</MenuItem>
                    <MenuItem value={'liquidada'}>Liquidada</MenuItem>
                    <MenuItem value={'resgate'}>Resgate</MenuItem>
                    <MenuItem value={'encerrada'}>Encerrada</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Box>
          </TabPanel>

          <TabPanel value={value} index={1}>
            <Box>
              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Selecione o investidor</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={personne_id}
                    label="Selecione o investidor"
                    onChange={e => setPersonne_id(e.target.value)}
                  >
                    {personne.length > 0 && personne.map(personne => (
                      <MenuItem value={personne.id}>{personne.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              
            </Box>
          </TabPanel>

          <TabPanel value={value} index={2}>
            <Box
              component="form"
              noValidate
              autoComplete="off"
              sx={{
              width: '100%',
              maxWidth: '100%',
            }}>
              <TextField
                fullWidth
                id="outlined-number"
                label="Número da CPR"
                type="number"
                variant="outlined"
                value={cprNumber}
                onChange={event => setCprNumber(event.target.value)} />
            </Box>
          </TabPanel>
        </Box>
      </Box>

      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        gap: 1,
        padding: 2,
        borderRadius: '0 0 8px 8px',
        backgroundColor: '#fff'
      }}>
        <Button variant="contained" color={'success'}>
          <Typography color={'#fff'} onClick={() => handleReturnInfos()}>
            Filtrar
          </Typography>
        </Button>
        <Button variant="contained" onClick={onClose}>
          <Typography color={'#fff'}>
            Fechar
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}
